import './lib/readmore-fixed';

export function readMore()
{
    $('.filter__section').each( function() {
        var element = $(this);
        var height = element.height();

        if (height > 213) {
            element.toggleClass('filter__section--hide').addClass('filter__section--overflow');
            element.after(
                '<div class="filter__section__button"><i class="fas fa-angle-down mr-3"></i><div class="filter__section__button__text">Meer</div></div>'
            );
        }
    });

    $('.filter__section__button').on('click', function() {
        const button = $(this);
        const text = button.find('.filter__section__button__text');

        // Toggle button class
        button.toggleClass('open');

        // Toggle icons
        const icon = button.find('.fas');
        icon.toggleClass('fa-angle-down fa-angle-up');

        // Select filter__section and trigger classes
        const element = button.prev();
        element.toggleClass('filter__section--open filter__section--hide');

        if( button.hasClass('open') ) {
            text.html('Minder');
        } else {
            text.html('Meer');
        }
    });
}

$(function () {
    if (screen.width < 767) {
        $('.single-preek__content__text').readmore({
            embedCSS: true,
            moreLink: '<a href="#" class="btn btn--primary--light mt-4 mb-4">Lees meer</a>',
            lessLink: '<a href="#" class="btn btn--primary--light mt-4 mb-4" onclick="window.scrollTo(\'.single-preek__content__text\')">Toon minder</a>',
            collapsedHeight: 118,
        })
    } else {
        $('.single-preek__content__text').readmore({
            embedCSS: true,
            moreLink: '<a href="#" class="btn btn--primary--light mt-4 mb-4">Lees meer</a>',
            lessLink: '<a href="#" class="btn btn--primary--light mt-4 mb-4" onclick="window.scrollTo(\'.single-preek__content__text\')">Toon minder</a>',
            collapsedHeight: 224,
        })
    }

});

// Read more for module-info
$('.info__item__content:not(.disable-collapse):not(.disable-readmore)').readmore({
    embedCSS: true,
    moreLink: '<div class="btn btn--primary--dark toggle-info"><i class="fas fa-angle-down"></i></div>',
    lessLink: '<div class="btn btn--primary--dark toggle-info"><i class="fas fa-angle-up"></i></div>',
    collapsedHeight: 55,
});

// Read more for nummers
$('.nummer-item__button').on('click', function() {
    const item = $(this).parent().parent().parent().next();
    const button = $(this).find('.fas');
    item.slideToggle();
    button.toggleClass('fa-angle-down fa-angle-up');
    console.log(button);
})
